<template>
  <b-modal
    id="modal-prevent-closing"
    ref="modal"
    v-model="showModal"
    hide-footer
    centered
    noCloseOnBackdrop
  >
    <template #modal-title> change {{ currentData.item.name }} panel </template>
    <validation-observer ref="changePanelForm" #default="{ invalid }">
      <b-form class="auth-add-user-form my-2" @submit.prevent="changePanel">
        <b-form-group
          label="Select panel :"
          label-for="select-panel"
          class="w-100"
        >
          <validation-provider
            #default="{ errors }"
            name="Select panel"
            vid="select-panel"
            class="w-100"
          >
            <div class="d-flex justify-content-start align-items-center">
              <select-box
                id="panel"
                v-model="plan"
                :lists="plans"
                label="name"
                class="w-100"
                select="id"
                searchable
                searchableSimple
                :loader="plansLoading"
              />
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-button
          block
          type="submit"
          class="my-1 gradient-btn"
          :disabled="
            (currentData.item &&
              currentData.item.plan &&
              currentData.item.plan.id &&
              plan == currentData.item.plan.id) ||
            !plan
          "
        >
          {{
            currentData.item &&
            currentData.item.plan &&
            currentData.item.plan.id &&
            currentData.item.plan.id == plan
              ? "Current plan"
              : "Change panel"
          }}
        </b-button>
      </b-form>
    </validation-observer>
    <loader :loading="loading" />
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
  BModal,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import SelectBox from "@/@core/components/select-box/SelectBox";
export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BModal,
    Loader,
    SelectBox,
  },
  data() {
    return {
      plan: "",
      loading: false,
      required,
      plans: [],
      plansLoading: false,
    };
  },
  computed: {
    showModal: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.visible;
      },
    },
  },
  props: {
    currentData: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.getPlans();
  },
  watch: {
    currentData(val) {
      this.plan =
        val.item && val.item.plan && val.item.plan.id ? val.item.plan.id : "";
    },
  },
  methods: {
    async getPlans() {
      this.plansLoading = true;
      try {
        const { data } = await this.$http.get("/panel/plans");
        this.plans = data.data;
      } catch (error) {}
      this.plansLoading = false;
    },
    changePanel() {
      this.$refs.changePanelForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            const { data } = await this.$http.put(
              `/panel/partners/${this.currentData.item.id}/plans/${this.plan}`
            );
            this.$emit("updateUsers");
          } catch (err) {}
          this.loading = false;
          this.showModal = false;
        }
      });
    },
  },
};
</script>
